import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {WinterHoardLayerConfig} from "../config/WinterHoardLayerConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Timeline, TimelineLite} from "gsap";
import {WinterHoardTextStyles} from "../config/WinterHoardTextStyles";
import {WinterHoardGameModuleConfig} from "../WinterHoardGameModuleConfig";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SoundPlayer} from "../sound/SoundPlayer";
import {WinterHoardSoundConfig} from "../WinterHoardSoundConfig";
import {WinterHoardReelSymbol} from "../symbols/WinterHoardReelSymbol";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";


export class IndicatorBackgroundView extends BaseView {

    private _useFourTreeCoords:boolean = false;

    private _landscapeHolder:PIXI.Sprite;
    private _portraitHolder:PIXI.Sprite;
    private _m1FramePortrait:PIXI.Sprite;
    private _m1FrameLandscape:PIXI.Sprite;
    private _xOffset:number = -67;
    private _yOffset:number = -54;

    // indicators
    private _landscapeFrameWrapper:PIXI.Sprite;
    private _portraitFrameWrapper:PIXI.Sprite;
    private _landscapeIndicatorFrames:PIXI.Sprite [] = [];
    private _portraitIndicatorFrames:PIXI.Sprite [] = [];

    private _landscapeFrames:PIXI.Sprite [] = [];
    private _portraitFrames:PIXI.Sprite [] = [];

    // MP labels
    private _mpLabelsLandscape: PIXI.BitmapText [] = [];
    private _mpLabelsPortrait: PIXI.BitmapText [] = [];

    private _labelLandscapeMultiplierX: number [] = [];
    private _labelPortraitMultiplierX: number [] = [];
    private _labelLandscapeCombinedX: number [] = [];
    private _labelPortraitCombinedX: number [] = [];

    private _isTotallyFilled:boolean = false;

    private _meterEnergyNames: string [] = [];

    // Indicator effects
    private _transformEffect: {
        M1: {
            blast: TimelineSprite | null,
            flip: TimelineSprite  | null,
            energy: TimelineSprite | null,
            meterEnergy: PIXI.Sprite | null
        },
        M2: {
            blast: TimelineSprite | null,
            flip: TimelineSprite | null,
            energy: TimelineSprite | null,
            meterEnergy: PIXI.Sprite | null
        },
        M3: {
            blast: TimelineSprite | null,
            flip: TimelineSprite | null,
            energy: TimelineSprite | null,
            meterEnergy: PIXI.Sprite | null
        },
        M4: {
            blast: TimelineSprite | null,
            flip: TimelineSprite | null,
            energy: TimelineSprite | null,
            meterEnergy: PIXI.Sprite | null
        },
        M5: {
            blast: TimelineSprite | null,
            flip: TimelineSprite | null,
            energy: TimelineSprite | null,
            meterEnergy: PIXI.Sprite | null
        }
    } = {
        M1: {
            blast: null,
            flip: null,
            energy: null,
            meterEnergy: null
        },
        M2: {
            blast: null,
            flip: null,
            energy: null,
            meterEnergy: null
        },
        M3: {
            blast: null,
            flip: null,
            energy: null,
            meterEnergy: null
        },
        M4: {
            blast: null,
            flip: null,
            energy: null,
            meterEnergy: null
        },
        M5: {
            blast: null,
            flip: null,
            energy: null,
            meterEnergy: null
        }
    };

    private _portraitTransformEffect: {
        M1: {
            blast: TimelineSprite | null,
            flip: TimelineSprite  | null,
            energy: TimelineSprite | null,
            meterEnergy: PIXI.Sprite | null
        },
        M2: {
            blast: TimelineSprite | null,
            flip: TimelineSprite | null,
            energy: TimelineSprite | null,
            meterEnergy: PIXI.Sprite | null
        },
        M3: {
            blast: TimelineSprite | null,
            flip: TimelineSprite | null,
            energy: TimelineSprite | null,
            meterEnergy: PIXI.Sprite | null
        },
        M4: {
            blast: TimelineSprite | null,
            flip: TimelineSprite | null,
            energy: TimelineSprite | null,
            meterEnergy: PIXI.Sprite | null
        },
        M5: {
            blast: TimelineSprite | null,
            flip: TimelineSprite | null,
            energy: TimelineSprite | null,
            meterEnergy: PIXI.Sprite | null
        }
    } = {
        M1: {
            blast: null,
            flip: null,
            energy: null,
            meterEnergy: null
        },
        M2: {
            blast: null,
            flip: null,
            energy: null,
            meterEnergy: null
        },
        M3: {
            blast: null,
            flip: null,
            energy: null,
            meterEnergy: null
        },
        M4: {
            blast: null,
            flip: null,
            energy: null,
            meterEnergy: null
        },
        M5: {
            blast: null,
            flip: null,
            energy: null,
            meterEnergy: null
        }
    };

    private _landscapeMeterEnergyAnimations: {
        M2: string [],
        M3: string [],
        M4: string [],
        M5: string []
    } = {
        M2: [],
        M3: [],
        M4: [],
        M5: []
    };
    private _portraitMeterEnergyAnimations: {
        M2: string [],
        M3: string [],
        M4: string [],
        M5: string []
    } = {
        M2: [],
        M3: [],
        M4: [],
        M5: []
    };

    private _landscapeDeactivatedStrings: {
        M1:string, M2:string, M3:string, M4:string, M5:string
    } = {
        M1: "buffaloCoverLandscape",
        M2: "eagleCoverLandscape",
        M3: "cougarCoverLandscape",
        M4: "coyoteCoverLandscape",
        M5: "pronghornCoverLandscape"
    };
    private _landscapeActivatedStrings: {
        M1:string, M2:string, M3:string, M4:string, M5:string
    } = {
        M1: "buffaloRevealLandscape",
        M2: "eagleRevealLandscape",
        M3: "cougarRevealLandscape",
        M4: "coyoteRevealLandscape",
        M5: "pronghornRevealLandscape"
    };
    private _landscapeDeactivated: PIXI.Sprite [] = [];
    private _landscapeActivated: PIXI.Sprite [] = [];
    private _landscapeFilled: PIXI.Sprite [] = [];

    private _portraitDeactivatedStrings: {
        M1:string, M2:string, M3:string, M4:string, M5:string
    } = {
        M1: "buffaloCoverPortrait",
        M2: "eagleCoverPortrait",
        M3: "cougarCoverPortrait",
        M4: "coyoteCoverPortrait",
        M5: "pronghornCoverPortrait"
    };
    private _portraitActivatedStrings: {
        M1:string, M2:string, M3:string, M4:string, M5:string
    } = {
        M1: "buffaloRevealPortrait",
        M2: "eagleRevealPortrait",
        M3: "cougarRevealPortrait",
        M4: "coyoteRevealPortrait",
        M5: "pronghornRevealPortrait"
    };
    private _portraitDeactivated: PIXI.Sprite [] = [];
    private _portraitActivated: PIXI.Sprite [] = [];
    private _portraitFilled: PIXI.Sprite [] = [];

    private _mode:string = "";

    // FS Intense
    private _bigThunderSpine:PIXI.spine.Spine;
    private _bigThunderSprite:PIXI.Sprite;

    private _meterThunderSprite:PIXI.Sprite;
    private _meterThunderSpine:PIXI.spine.Spine;

    private _raySpine:PIXI.spine.Spine;
    private _raySprite:PIXI.Sprite;

    private _rays:string;
    private _rayDuration:number = 0;

    private _meterThunder:string;
    private _meterThunderDuration:number = 0;

    private _bigThunder:string;
    private _bigThunderDuration:number = 0;

    private _thunderLayer:ScalableLayer;
    private _rayLayer:ScalableLayer;

    // FS Intense Portrait
    private _bigThunderSpinePortrait:PIXI.spine.Spine;
    private _bigThunderSpritePortrait:PIXI.Sprite;

    private _meterThunderSpritePortrait:PIXI.Sprite;
    private _meterThunderSpinePortrait:PIXI.spine.Spine;

    constructor() {
        super();
    }

    protected initAnimations():void {
        // TODO: Move logo here.

        StageManager.getLayer(WinterHoardLayerConfig.INDICATOR_BG.name).addChild(this);
        this._thunderLayer = StageManager.getLayer(WinterHoardLayerConfig.FULL_LIGHTNING.name);
        this._rayLayer = StageManager.getLayer(WinterHoardLayerConfig.FS_RAYS.name);

        this._landscapeHolder = new PIXI.Sprite(GameResources.getTextures("landscapeHolder")[0]);
        this._portraitHolder = new PIXI.Sprite(GameResources.getTextures("portraitHolder")[0]);
        this._m1FramePortrait = new PIXI.Sprite(GameResources.getTextures("m1FramePortrait")[0]);
        this._m1FrameLandscape = new PIXI.Sprite(GameResources.getTextures("m1FrameLandscape")[0]);

        this.addChild(this._landscapeHolder);
        this.addChild(this._portraitHolder);

        this._portraitHolder.addChild(this._m1FramePortrait);
        this._landscapeHolder.addChild(this._m1FrameLandscape);


        // Create holders & indicators
        this.createLabels();
        this.transformEffectSetup();
        this.indicatorSetup();
        this.createLandscapeIndicators();
        this.createPortraitIndicators();

        //this.visible = false;
        //this.activateEnteringFS();
        //this.deactivateExitingFS();

        this._labelLandscapeMultiplierX = [0, 0, 40, 40, 0];
        this._labelPortraitMultiplierX = [0, 0, 70, 70, 0];
        this._labelLandscapeCombinedX = [0, 0, 0, 0, 0];
        this._labelPortraitCombinedX = [0, 0, 0, 0, 0];

        this.showLabel(true);

        // Test meter energy
        //const testTL:TimelineMax = new TimelineMax({repeat: 0});

        /*[4, 3, 2, 1].forEach((level) => {
            [1, 2, 3, 4, 5].forEach((energy) => {
                testTL.add(() => {
                    this.fillMeterEnergy(level, energy);
                }, "+=0")
            });
        });*/

        this.createIntenseAnimations();

        //this.playThunderSpine(this._meterThunder, 0, true);
        //this.playThunderSpine(this._bigThunder, 0, true);
        //this.playRaySpine();
    }

    protected intenseOnResize(orientation:Orientation):void {

        if(orientation === Orientation.LANDSCAPE) {
            this._meterThunderSprite.visible = true;
            this._bigThunderSprite.visible = true;

            this._meterThunderSpritePortrait.visible = false;
            this._bigThunderSpritePortrait.visible = false;

        }
        else {
            this._meterThunderSpritePortrait.visible = true;
            this._bigThunderSpritePortrait.visible = true;

            this._meterThunderSprite.visible = false;
            this._bigThunderSprite.visible = false;
        }
    }

    protected createIntenseAnimations():void {
        /*
            0: Animation {name: "big_thunder", timelines: Array(29), duration: 0.33329999446868896}
            1: Animation {name: "last_level_rays", timelines: Array(59), duration: 2.566699981689453}
            2: Animation {name: "meter_thunder", timelines: Array(30), duration: 0.5}
        */
        const sprite:PIXI.Sprite = this._bigThunderSprite = new PIXI.Sprite();
        const spine:PIXI.spine.Spine = this._bigThunderSpine = new PIXI.spine.Spine(GameResources.getSpineAsset("fsIntense"));

        const meterSprite:PIXI.Sprite = this._meterThunderSprite = new PIXI.Sprite();
        const meterSpine:PIXI.spine.Spine = this._meterThunderSpine = new PIXI.spine.Spine(GameResources.getSpineAsset("fsIntense"));

        const pSprite:PIXI.Sprite = this._bigThunderSpritePortrait = new PIXI.Sprite();
        const pSpine:PIXI.spine.Spine = this._bigThunderSpinePortrait = new PIXI.spine.Spine(GameResources.getSpineAsset("fsIntense"));

        const pMeterSprite:PIXI.Sprite = this._meterThunderSpritePortrait = new PIXI.Sprite();
        const pMeterSpine:PIXI.spine.Spine = this._meterThunderSpinePortrait = new PIXI.spine.Spine(GameResources.getSpineAsset("fsIntense"));

        const raySprite:PIXI.Sprite = this._raySprite = new PIXI.Sprite();
        const raySpine:PIXI.spine.Spine = this._raySpine = new PIXI.spine.Spine(GameResources.getSpineAsset("fsIntense"));

        //sprite.blendMode = PIXI.BLEND_MODES.;
        //sprite.anchor.set(0.5, 0.5);
        sprite.addChild(spine);
        sprite.position.set(-30, 320);

        pSprite.addChild(pSpine);
        pSprite.position.set(260, -150);
        pSprite.rotation = 2.299626707551;

        raySprite.addChild(raySpine);
        raySprite.alpha = 0.5;
        raySprite.position.set(360, 740);

        meterSprite.addChild(meterSpine);
        meterSprite.position.set(140, 140);

        pMeterSprite.addChild(pMeterSpine);
        pMeterSprite.position.set(120, 140);
        pMeterSprite.rotation = -0.872665;

        //console.log("FS INTENSE ANIMATIONS");
        //console.log(spine.skeleton.data.animations);

        this._rays = spine.skeleton.data.animations[1].name;
        this._rayDuration = spine.skeleton.data.animations[1].duration;

        this._meterThunder = spine.skeleton.data.animations[2].name;
        this._meterThunderDuration = spine.skeleton.data.animations[2].duration;

        this._bigThunder = spine.skeleton.data.animations[0].name;
        this._bigThunderDuration = spine.skeleton.data.animations[0].duration;


        this._thunderLayer.addChild(sprite);
        this._thunderLayer.addChild(pSprite);

        this._rayLayer.addChild(raySprite);
        this._m1FrameLandscape.addChild(meterSprite);
        this._m1FramePortrait.addChild(pMeterSprite);

        //new TimelineMax({repeat: -1}).add(() => {
           //eterSpine.state.setAnimation(0, this._meterThunder, true);
           //spine.state.setAnimation(0, this._bigThunder, true);
        //}, 0.2);

        sprite.renderable = false;
        pSprite.renderable = false;
        raySprite.renderable = false;
        meterSprite.renderable = false;
        pMeterSprite.renderable = false;
    }

    protected playThunderSpine(animName:string = "", duration:number = 0, loop:boolean = false):Timeline {
        const tl:Timeline = new TimelineLite();

        //debugger;

        if(animName !== "") {
            let dur: number = duration;
            let spine:PIXI.spine.Spine | undefined = undefined;
            let sprite:PIXI.Sprite | undefined = undefined;
            let pSpine:PIXI.spine.Spine | undefined = undefined;
            let pSprite:PIXI.Sprite | undefined = undefined;
            let name:string | undefined = undefined;


            if(animName === this._bigThunder) {
                spine = this._bigThunderSpine;
                sprite = this._bigThunderSprite;
                pSpine = this._bigThunderSpinePortrait;
                pSprite = this._bigThunderSpritePortrait;
                name = this._bigThunder;
                dur = this._bigThunderDuration;
            }
            else if(animName === this._meterThunder) {
                spine = this._meterThunderSpine;
                sprite = this._meterThunderSprite;
                pSpine = this._meterThunderSpinePortrait;
                pSprite = this._meterThunderSpritePortrait;
                name = this._meterThunder;
                dur = this._meterThunderDuration;
            }

            if(spine && sprite && name) {
                tl.add(() => {
                    if(spine && sprite && name) {
                        sprite.renderable = true;
                        spine.state.setAnimation(0, name, loop);
                    }
                    if(pSpine && pSprite && name) {
                        pSprite.renderable = true;
                        pSpine.state.setAnimation(0, name, loop);
                    }
                });
                tl.add(() => {
                    if(spine && sprite && name) {
                        sprite.renderable = false;
                        spine.state.setEmptyAnimation(0, 0);
                    }
                    if(pSpine && pSprite && name) {
                        pSprite.renderable = false;
                        pSpine.state.setEmptyAnimation(0, 0);
                    }
                }, dur * 2);
            }
        }

        return tl;
    }


    protected playRaySpine():Timeline {
        const tl:Timeline = new TimelineLite();
        const duration:number = this._rayDuration;

        tl.add(() => {
            this._raySprite.renderable = true;
            this._raySpine.state.setAnimation(0, this._rays, true);
        });
        tl.add(() => {

        }, duration);

        return tl;
    }

    protected stopRaySpine():void {
        this._raySprite.renderable = false;
        this._raySpine.state.setEmptyAnimation(0,0);
    }

    protected indicatorSetup():void {
        [1, 2, 3, 4, 5].forEach((value) => {
           switch(value) {
               case 1:
                   this._landscapeDeactivated.push(new PIXI.Sprite(GameResources.getTextures(this._landscapeDeactivatedStrings.M1)[0]));
                   this._landscapeActivated.push(new PIXI.Sprite(GameResources.getTextures(this._landscapeActivatedStrings.M1)[0]));

                   this._portraitDeactivated.push(new PIXI.Sprite(GameResources.getTextures(this._portraitDeactivatedStrings.M1)[0]));
                   this._portraitActivated.push(new PIXI.Sprite(GameResources.getTextures(this._portraitActivatedStrings.M1)[0]));


                   // TODO: no statement here, setup for both modes
                   if(value === 1) {
                       const fillSymLandscape: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures(this._landscapeActivatedStrings.M1)[0]);
                       const fillSymPortrait: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures(this._portraitActivatedStrings.M1)[0]);

                       fillSymLandscape.scale.set(0.7, 0.7);
                       fillSymLandscape.anchor.set(0.15, 0.20);

                       this._landscapeFilled.push(fillSymLandscape);
                       this._portraitFilled.push(fillSymPortrait);
                   }

                   break;
               case 2:
                   this._landscapeDeactivated.push(new PIXI.Sprite(GameResources.getTextures(this._landscapeDeactivatedStrings.M2)[0]));
                   this._landscapeActivated.push(new PIXI.Sprite(GameResources.getTextures(this._landscapeActivatedStrings.M2)[0]));

                   this._portraitDeactivated.push(new PIXI.Sprite(GameResources.getTextures(this._portraitDeactivatedStrings.M2)[0]));
                   this._portraitActivated.push(new PIXI.Sprite(GameResources.getTextures(this._portraitActivatedStrings.M2)[0]));

                   // IF multiplier mode or transform mode
                   if(value === 2) {
                       const fillSymLandscape:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures(this._landscapeActivatedStrings.M2)[0]);
                       const fillSymPortrait:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures(this._portraitActivatedStrings.M2)[0]);

                       fillSymLandscape.scale.set(0.7, 0.7);
                       fillSymLandscape.anchor.set(0.15, 0.20);

                       this._landscapeFilled.push(fillSymLandscape);
                       this._portraitFilled.push(fillSymPortrait);
                   }
                   break;
               case 3:
                   this._landscapeDeactivated.push(new PIXI.Sprite(GameResources.getTextures(this._landscapeDeactivatedStrings.M3)[0]));
                   this._landscapeActivated.push(new PIXI.Sprite(GameResources.getTextures(this._landscapeActivatedStrings.M3)[0]));

                   this._portraitDeactivated.push(new PIXI.Sprite(GameResources.getTextures(this._portraitDeactivatedStrings.M3)[0]));
                   this._portraitActivated.push(new PIXI.Sprite(GameResources.getTextures(this._portraitActivatedStrings.M3)[0]));

                   // IF multiplier mode or transform mode
                   if(value === 3) {
                       const fillSymLandscape:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures(this._landscapeActivatedStrings.M3)[0]);
                       const fillSymPortrait:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures(this._portraitActivatedStrings.M3)[0]);

                       fillSymLandscape.scale.set(0.7, 0.7);
                       fillSymLandscape.anchor.set(0.15, 0.20);

                       this._landscapeFilled.push(fillSymLandscape);
                       this._portraitFilled.push(fillSymPortrait);
                   }
                   break;
               case 4:
                   this._landscapeDeactivated.push(new PIXI.Sprite(GameResources.getTextures(this._landscapeDeactivatedStrings.M4)[0]));
                   this._landscapeActivated.push(new PIXI.Sprite(GameResources.getTextures(this._landscapeActivatedStrings.M4)[0]));

                   this._portraitDeactivated.push(new PIXI.Sprite(GameResources.getTextures(this._portraitDeactivatedStrings.M4)[0]));
                   this._portraitActivated.push(new PIXI.Sprite(GameResources.getTextures(this._portraitActivatedStrings.M4)[0]));

                   // IF multiplier mode or transform mode
                   if(value === 4) {
                       const fillSymLandscape:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures(this._landscapeActivatedStrings.M4)[0]);
                       const fillSymPortrait:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures(this._portraitActivatedStrings.M4)[0]);

                       fillSymLandscape.scale.set(0.7, 0.7);
                       fillSymLandscape.anchor.set(0.15, 0.20);

                       this._landscapeFilled.push(fillSymLandscape);
                       this._portraitFilled.push(fillSymPortrait);
                   }
                   break;
               case 5:
                   this._landscapeDeactivated.push(new PIXI.Sprite(GameResources.getTextures(this._landscapeDeactivatedStrings.M5)[0]));
                   this._landscapeActivated.push(new PIXI.Sprite(GameResources.getTextures(this._landscapeActivatedStrings.M5)[0]));

                   this._portraitDeactivated.push(new PIXI.Sprite(GameResources.getTextures(this._portraitDeactivatedStrings.M5)[0]));
                   this._portraitActivated.push(new PIXI.Sprite(GameResources.getTextures(this._portraitActivatedStrings.M5)[0]));

                   // IF multiplier mode or transform mode
                   if(value === 5) {
                       const fillSymLandscape:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures(this._landscapeActivatedStrings.M4)[0]);
                       const fillSymPortrait:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures(this._portraitActivatedStrings.M4)[0]);

                       fillSymLandscape.scale.set(0.7, 0.7);
                       fillSymLandscape.anchor.set(0.15, 0.20);

                       this._landscapeFilled.push(fillSymLandscape);
                       this._portraitFilled.push(fillSymPortrait);
                   }
                   break;
           }
        });
    }

    transformEffectSetup():void {
        let spine:PIXI.spine.Spine;
        [0, 1, 2, 3, 4].forEach((val:number) => {
            switch(val) {
                case 0:
                    const tEffectsM1:{ blast: TimelineSprite | null, flip: TimelineSprite | null, energy: TimelineSprite | null, meterEnergy: PIXI.Sprite | null} = this._transformEffect.M1;

                    tEffectsM1.blast = new TimelineSprite(GameResources.getTextures("meterBlast"));
                    tEffectsM1.energy = new TimelineSprite(GameResources.getTextures("meterEnergy"));
                    tEffectsM1.flip = new TimelineSprite(GameResources.getTextures("meterFlip"));

                    tEffectsM1.energy.blendMode = PIXI.BLEND_MODES.ADD;

                    // TODO: Meter Energy
                    //tEffectsM1.meterEnergy = new PIXI.Sprite();
                    //tEffectsM1.meterEnergy.addChild(spine = new PIXI.spine.Spine(GameResources.getSpineAsset("meterEnergy")));


                    // TODO: Add portrait
                    const tEffectsM1portrait:{ blast: TimelineSprite | null, flip: TimelineSprite | null, energy: TimelineSprite | null, meterEnergy: PIXI.Sprite | null} = this._portraitTransformEffect.M1;

                    tEffectsM1portrait.blast = new TimelineSprite(GameResources.getTextures("meterBlast"));
                    tEffectsM1portrait.energy = new TimelineSprite(GameResources.getTextures("meterEnergy"));
                    tEffectsM1portrait.flip = new TimelineSprite(GameResources.getTextures("meterFlip"));

                    tEffectsM1portrait.energy.blendMode = PIXI.BLEND_MODES.ADD;

                    // TODO: Meter Energy
                    //tEffectsM1portrait.meterEnergy = new PIXI.Sprite();
                    //tEffectsM1portrait.meterEnergy.addChild(new PIXI.spine.Spine(GameResources.getSpineAsset("meterEnergy")));

                    break;
                case 1:
                    const tEffectsM2:{ blast: TimelineSprite | null, flip: TimelineSprite | null, energy: TimelineSprite | null, meterEnergy: PIXI.Sprite | null} = this._transformEffect.M2;

                    tEffectsM2.blast = new TimelineSprite(GameResources.getTextures("meterBlast"));

                    tEffectsM2.energy = new TimelineSprite(GameResources.getTextures("meterEnergy"));
                    //tEffectsM2.energy.anchor.set(0.5, 0.5);
                    tEffectsM2.energy.blendMode = PIXI.BLEND_MODES.ADD;
                    tEffectsM2.flip = new TimelineSprite(GameResources.getTextures("meterFlip"));


                    // TODO: Energy spine
                    const tEffectsM2portrait:{ blast: TimelineSprite | null, flip: TimelineSprite | null, energy: TimelineSprite | null, meterEnergy: PIXI.Sprite | null} = this._portraitTransformEffect.M2;

                    tEffectsM2portrait.blast = new TimelineSprite(GameResources.getTextures("meterBlast"));
                    tEffectsM2portrait.energy = new TimelineSprite(GameResources.getTextures("meterEnergy"));
                    tEffectsM2portrait.flip = new TimelineSprite(GameResources.getTextures("meterFlip"));

                    tEffectsM2portrait.energy.blendMode = PIXI.BLEND_MODES.ADD;

                    // TODO: Meter Energy
                    tEffectsM2.meterEnergy = new PIXI.Sprite();
                    tEffectsM2.meterEnergy.addChild(spine = new PIXI.spine.Spine(GameResources.getSpineAsset("meterEnergy")));

                    /*spine.skeleton.data.animations.forEach((anim) => {
                        this._landscapeMeterEnergyAnimations.M2.push(anim.name);
                    });*/

                    [1, 3, 5, 7, 9].forEach((value) => {
                        this._landscapeMeterEnergyAnimations.M2.push(spine.skeleton.data.animations[value].name);
                    });

                    //spine.state.setAnimation(0, this._landscapeMeterEnergyAnimations.M2[0], true);

                    tEffectsM2portrait.meterEnergy = new PIXI.Sprite();
                    tEffectsM2portrait.meterEnergy.addChild(spine = new PIXI.spine.Spine(GameResources.getSpineAsset("meterEnergy")));
                    spine.x = - 2;

                    // TODO: Logout energy spine
                    //console.log("SPINE ENERGY: ");
                    //console.log(spine.skeleton.data.animations);


                    /*spine.skeleton.data.animations.forEach((anim) => {
                        this._portraitMeterEnergyAnimations.M2.push(anim.name);
                    });*/
                    [1, 3, 5, 7, 9].forEach((value) => {
                        this._portraitMeterEnergyAnimations.M2.push(spine.skeleton.data.animations[value].name);
                    });

                    //spine.state.setAnimation(0, this._portraitMeterEnergyAnimations.M2[0], true);
                    break;
                case 2:
                    const tEffectsM3:{ blast: TimelineSprite | null, flip: TimelineSprite | null, energy: TimelineSprite | null, meterEnergy: PIXI.Sprite | null} = this._transformEffect.M3;

                    tEffectsM3.blast = new TimelineSprite(GameResources.getTextures("meterBlast"));
                    tEffectsM3.energy = new TimelineSprite(GameResources.getTextures("meterEnergy"));
                    tEffectsM3.flip = new TimelineSprite(GameResources.getTextures("meterFlip"));

                    tEffectsM3.energy.blendMode = PIXI.BLEND_MODES.ADD;

                    // TODO: Add portrait
                    const tEffectsM3portrait:{ blast: TimelineSprite | null, flip: TimelineSprite | null, energy: TimelineSprite | null, meterEnergy: PIXI.Sprite | null} = this._portraitTransformEffect.M3;

                    tEffectsM3portrait.blast = new TimelineSprite(GameResources.getTextures("meterBlast"));
                    tEffectsM3portrait.energy = new TimelineSprite(GameResources.getTextures("meterEnergy"));
                    tEffectsM3portrait.flip = new TimelineSprite(GameResources.getTextures("meterFlip"));

                    tEffectsM3portrait.energy.blendMode = PIXI.BLEND_MODES.ADD;


                    // TODO: Meter Energy
                    tEffectsM3.meterEnergy = new PIXI.Sprite();
                    tEffectsM3.meterEnergy.addChild(spine = new PIXI.spine.Spine(GameResources.getSpineAsset("meterEnergy")));

                    /*spine.skeleton.data.animations.forEach((anim) => {
                        this._landscapeMeterEnergyAnimations.M3.push(anim.name);
                    });*/

                    [1, 3, 5, 7, 9].forEach((value) => {
                        this._landscapeMeterEnergyAnimations.M3.push(spine.skeleton.data.animations[value].name);
                    });


                    //spine.state.setAnimation(0, this._landscapeMeterEnergyAnimations.M3[0], true);

                    tEffectsM3portrait.meterEnergy = new PIXI.Sprite();
                    tEffectsM3portrait.meterEnergy.addChild(spine = new PIXI.spine.Spine(GameResources.getSpineAsset("meterEnergy")));
                    spine.x = 2;

                    /*spine.skeleton.data.animations.forEach((anim) => {
                        this._portraitMeterEnergyAnimations.M3.push(anim.name);
                    });*/

                    [1, 3, 5, 7, 9].forEach((value) => {
                        this._portraitMeterEnergyAnimations.M3.push(spine.skeleton.data.animations[value].name);
                    });

                    //spine.state.setAnimation(0, this._portraitMeterEnergyAnimations.M3[0], true);
                    break;
                case 3:
                    const tEffectsM4:{ blast: TimelineSprite | null, flip: TimelineSprite | null, energy: TimelineSprite | null, meterEnergy: PIXI.Sprite | null} = this._transformEffect.M4;

                    tEffectsM4.blast = new TimelineSprite(GameResources.getTextures("meterBlast"));
                    tEffectsM4.energy = new TimelineSprite(GameResources.getTextures("meterEnergy"));
                    tEffectsM4.flip = new TimelineSprite(GameResources.getTextures("meterFlip"));

                    tEffectsM4.energy.blendMode = PIXI.BLEND_MODES.ADD;

                    // TODO: Add portrait
                    const tEffectsM4portrait:{ blast: TimelineSprite | null, flip: TimelineSprite | null, energy: TimelineSprite | null, meterEnergy: PIXI.Sprite | null} = this._portraitTransformEffect.M4;

                    tEffectsM4portrait.blast = new TimelineSprite(GameResources.getTextures("meterBlast"));
                    tEffectsM4portrait.energy = new TimelineSprite(GameResources.getTextures("meterEnergy"));
                    tEffectsM4portrait.flip = new TimelineSprite(GameResources.getTextures("meterFlip"));

                    tEffectsM4portrait.energy.blendMode = PIXI.BLEND_MODES.ADD;


                    // TODO: Meter Energy
                    tEffectsM4.meterEnergy = new PIXI.Sprite();
                    tEffectsM4.meterEnergy.addChild(spine = new PIXI.spine.Spine(GameResources.getSpineAsset("meterEnergy")));

                    /*spine.skeleton.data.animations.forEach((anim) => {
                        this._landscapeMeterEnergyAnimations.M4.push(anim.name);
                    });*/

                    [1, 3, 5, 7, 9].forEach((value) => {
                        this._landscapeMeterEnergyAnimations.M4.push(spine.skeleton.data.animations[value].name);
                    });
                    //spine.state.setAnimation(0, this._landscapeMeterEnergyAnimations.M4[0], true);

                    tEffectsM4portrait.meterEnergy = new PIXI.Sprite();
                    tEffectsM4portrait.meterEnergy.addChild(spine = new PIXI.spine.Spine(GameResources.getSpineAsset("meterEnergy")));
                    spine.x = 2;

                    /*spine.skeleton.data.animations.forEach((anim) => {
                        this._portraitMeterEnergyAnimations.M4.push(anim.name);
                    });*/

                    [1, 3, 5, 7, 9].forEach((value) => {
                        this._portraitMeterEnergyAnimations.M4.push(spine.skeleton.data.animations[value].name);
                    });
                    //spine.state.setAnimation(0, this._portraitMeterEnergyAnimations.M4[0], true);

                    break;
                case 4:
                    const tEffectsM5:{ blast: TimelineSprite | null, flip: TimelineSprite | null, energy: TimelineSprite | null, meterEnergy: PIXI.Sprite | null} = this._transformEffect.M5;

                    tEffectsM5.blast = new TimelineSprite(GameResources.getTextures("meterBlast"));
                    tEffectsM5.energy = new TimelineSprite(GameResources.getTextures("meterEnergy"));
                    tEffectsM5.flip = new TimelineSprite(GameResources.getTextures("meterFlip"));

                    tEffectsM5.energy.blendMode = PIXI.BLEND_MODES.ADD;

                    // TODO: Add portrait
                    const tEffectsM5portrait:{ blast: TimelineSprite | null, flip: TimelineSprite | null, energy: TimelineSprite | null, meterEnergy: PIXI.Sprite | null} = this._portraitTransformEffect.M5;

                    tEffectsM5portrait.blast = new TimelineSprite(GameResources.getTextures("meterBlast"));
                    tEffectsM5portrait.energy = new TimelineSprite(GameResources.getTextures("meterEnergy"));
                    tEffectsM5portrait.flip = new TimelineSprite(GameResources.getTextures("meterFlip"));

                    tEffectsM5portrait.energy.blendMode = PIXI.BLEND_MODES.ADD;


                    // TODO: Meter Energy
                    tEffectsM5.meterEnergy = new PIXI.Sprite();
                    tEffectsM5.meterEnergy.addChild(spine = new PIXI.spine.Spine(GameResources.getSpineAsset("meterEnergy")));

                    /*spine.skeleton.data.animations.forEach((anim) => {
                        this._landscapeMeterEnergyAnimations.M5.push(anim.name);
                    });*/

                    [1, 3, 5, 7, 9].forEach((value) => {
                        this._landscapeMeterEnergyAnimations.M5.push(spine.skeleton.data.animations[value].name);
                    });
                    //spine.state.setAnimation(0, this._landscapeMeterEnergyAnimations.M5[1], true);

                    tEffectsM5portrait.meterEnergy = new PIXI.Sprite();
                    tEffectsM5portrait.meterEnergy.addChild(spine = new PIXI.spine.Spine(GameResources.getSpineAsset("meterEnergy")));
                    spine.x = -2;

                    /*spine.skeleton.data.animations.forEach((anim) => {
                        this._portraitMeterEnergyAnimations.M5.push(anim.name);
                    });*/

                    [1, 3, 5, 7, 9].forEach((value) => {
                        this._portraitMeterEnergyAnimations.M5.push(spine.skeleton.data.animations[value].name);
                    });

                    //spine.state.setAnimation(0, this._portraitMeterEnergyAnimations.M5[1], true);
                    break;
            }
        });
    }

    protected createLabels():void {
        // new PIXI.BitmapText("x" + this._multiplier, WinterHoardTextStyles.MULTIPLIER_SYMBOL);

        [0,1,2,3,4].forEach((val) => {
            if(val === 0) {
                this._mpLabelsLandscape.push(new PIXI.BitmapText("x" + "1", WinterHoardTextStyles.MULTIPLIER_METER_M1));
                this._mpLabelsPortrait.push(new PIXI.BitmapText("x" + "1", WinterHoardTextStyles.MULTIPLIER_METER_M1));
            }
            else {
                this._mpLabelsLandscape.push(new PIXI.BitmapText("x" + "1", WinterHoardTextStyles.MULTIPLIER_METER));
                this._mpLabelsPortrait.push(new PIXI.BitmapText("x" + "1", WinterHoardTextStyles.MULTIPLIER_METER_P));
            }

            this._mpLabelsLandscape[val].visible = false;
            this._mpLabelsPortrait[val].visible = false;
        });
    }

    public showLabel(setup:boolean = false, mode:string = "FREESPIN_MULTIPLIER", level:number = 0):void {
        this._mode = mode;

        if(mode === "FREESPIN_COMBINED") {
            this._mpLabelsLandscape.forEach((label, index) => {
                label.x = this._labelLandscapeCombinedX[index];
            });
            this._mpLabelsPortrait.forEach((label, index) => {
                label.x = this._labelPortraitCombinedX[index];
            });
        }
        else {
            this._mpLabelsLandscape.forEach((label, index) => {
                label.x = this._labelLandscapeMultiplierX[index];
            });
            this._mpLabelsPortrait.forEach((label, index) => {
                label.x = this._labelPortraitMultiplierX[index];
            });
        }

        if(!setup) {

        }

    }


    protected createPortraitIndicators():void {
        this._portraitFrameWrapper = new PIXI.Sprite();
        this._portraitFrameWrapper.position.set(131,42);
        this._portraitFrameWrapper.scale.set(0.87, 0.87);

        const arr:PIXI.Sprite [] = [];

        // TODO: Cache frames to be able to hide them.

        [1, 2, 3, 4].forEach((value) => {
            const frame:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("blankMeterPortrait")[0]);
            frame.name = "frameId_" + value;
            frame.scale.set(1.1);
            //frame.alpha = 0.6;
            //frame.y = value * 100;

            switch(value) {
                case 1: // Eagle top left
                    frame.x = -32;
                    frame.y = 6;
                    break;
                case 2: // Cougar bottom left
                    frame.x = -116;
                    frame.y = 104;
                    break;
                case 3: // Coyote top right
                    frame.x = 293;
                    frame.y = 6;
                    break;
                case 4: // Pronghorn bottom right
                    frame.x = 378;
                    frame.y = 105;
                    break;
            }

            arr.push(frame);
            this._portraitIndicatorFrames.push(frame);
            this._portraitFrameWrapper.addChild(frame);
        });

        [0, 1, 2, 3, 4].forEach((value:number) => {
            const inactive:PIXI.Sprite = this._portraitDeactivated[value];

            const active:PIXI.Sprite = new PIXI.Sprite();
            this._portraitActivated[value] = active.addChild(this._portraitActivated[value]);

            let filled:PIXI.Sprite | null = this._portraitFilled[value];

            if(value === 0) {
                inactive.x = 103;
                inactive.y = 29;
                inactive.scale.set(1.35, 1.35);
                //inactive.anchor.set(0, 0);
                inactive.name = "inactive_" + value;

                active.x = 95;
                active.y = -15;
                active.scale.set(1.15, 1.15);
                //active.anchor.set(0, 0);
                active.name = "active_" + value;
                active.visible = false;

                //filled.x = -40;
                //filled.y = -190;
                //filled.name = "filled_" + value;
                filled = null;

                // TODO: ADD GLOW FRAME

                if(this._portraitTransformEffect.M1.energy) {
                    this._portraitTransformEffect.M1.energy.visible = false;
                    this._portraitTransformEffect.M1.energy.anchor.set(0.345, 0.28);
                    this._portraitTransformEffect.M1.energy.scale.set(2.35);
                    active.addChild(this._portraitTransformEffect.M1.energy);
                    //this._portraitTransformEffect.M1.energy.playLoop();
                }

                // MP LABEL
                const m1lbl:PIXI.BitmapText = this._mpLabelsPortrait[0];
                m1lbl.y = 125;
                active.addChild(m1lbl);

                // TODO: ADD BLAST
            }
            else {
                inactive.x = arr[value - 1].x;
                inactive.y = arr[value - 1].y;
                inactive.scale.set(1.25, 1.25);
                inactive.anchor.set(0.125, 0.125);
                inactive.name = "inactive_" + value;

                if(value === 1) {
                    inactive.x = arr[value - 1].x + 13;
                    inactive.y = arr[value - 1].y + 10;
                    active.x = arr[value - 1].x + 13;
                    active.y = arr[value - 1].y + 10;
                }
                else if (value === 4) {
                    active.x = arr[value - 1].x + 10;
                    active.y = arr[value - 1].y + 5;
                }
                else {
                    active.x = arr[value - 1].x;
                    active.y = arr[value - 1].y;
                }
                active.scale.set(1.15, 1.15);
                this._portraitActivated[value].anchor.set(0.125, 0.125);
            //active.anchor.set(0.125, 0.125);
                active.name = "active_" + value;
                active.visible = false;

                filled.x = arr[value - 1].x + 25;
                filled.y = arr[value - 1].y + 20;
                filled.name = "filled_" + value;
                filled.visible = false;

                const lbl:PIXI.BitmapText = this._mpLabelsPortrait[value];
                lbl.y = 50;

                switch(value) {
                    case 1:

                        if(this._portraitTransformEffect.M2.meterEnergy) {
                            //active.visible = true;
                            this._portraitTransformEffect.M2.meterEnergy.visible = false;
                            this._portraitTransformEffect.M2.meterEnergy.scale.set(1.35);
                            this._portraitTransformEffect.M2.meterEnergy.position.set(47, 47);
                            active.addChildAt(this._portraitTransformEffect.M2.meterEnergy, 0);
                        }

                        if(this._portraitTransformEffect.M2.flip) {
                            this._portraitTransformEffect.M2.flip.visible = false;
                            this._portraitTransformEffect.M2.flip.scale.set(1.25);
                            this._portraitTransformEffect.M2.flip.anchor.set(0.25, 0.24);
                            active.addChild(this._portraitTransformEffect.M2.flip);

                            //active.visible = true;
                            //this._portraitTransformEffect.M2.flip.getAnimationAutoShowHide(undefined, false);
                            //this._portraitTransformEffect.M2.flip.visible = true;
                            //this._portraitTransformEffect.M2.flip.playLoop();
                        }
                        if(this._portraitTransformEffect.M2.energy) {
                            this._portraitTransformEffect.M2.energy.visible = false;
                            this._portraitTransformEffect.M2.energy.scale.set(1.25);
                            this._portraitTransformEffect.M2.energy.anchor.set(0.35, 0.33);
                            active.addChild(this._portraitTransformEffect.M2.energy);

                            //this._portraitTransformEffect.M2.energy.playLoop();
                            //active.visible = true;
                            active.addChild(lbl);
                        }
                        if(this._portraitTransformEffect.M2.blast) {
                            //active.visible = true;

                            this._portraitTransformEffect.M2.blast.visible = false;
                            this._portraitTransformEffect.M2.blast.anchor.set(0.36, 0.37);
                            active.addChild(this._portraitTransformEffect.M2.blast);

                            //this._portraitTransformEffect.M2.blast.playLoop();
                        }
                        break;
                    case 2:

                        if(this._portraitTransformEffect.M3.meterEnergy) {
                            //active.visible = true;
                            this._portraitTransformEffect.M3.meterEnergy.visible = false;
                            this._portraitTransformEffect.M3.meterEnergy.scale.set(1.35);
                            this._portraitTransformEffect.M3.meterEnergy.position.set(50, 50);
                            active.addChildAt(this._portraitTransformEffect.M3.meterEnergy, 0);
                        }

                        if(this._portraitTransformEffect.M3.flip) {
                            //active.visible = true;

                            this._portraitTransformEffect.M3.flip.visible = false;
                            this._portraitTransformEffect.M3.flip.scale.set(1.25);
                            this._portraitTransformEffect.M3.flip.anchor.set(0.22, 0.21);
                            active.addChild(this._portraitTransformEffect.M3.flip);

                            //this._portraitTransformEffect.M3.flip.visible = true;
                            //this._portraitTransformEffect.M3.flip.playLoop();

                            //active.visible = true;
                            //this._portraitTransformEffect.M3.flip.getAnimationAutoShowHide(undefined, false);
                        }
                        if(this._portraitTransformEffect.M3.energy) {
                            //active.visible = true;

                            this._portraitTransformEffect.M3.energy.visible = false;
                            this._portraitTransformEffect.M3.energy.scale.set(1.25);
                            this._portraitTransformEffect.M3.energy.anchor.set(0.31, 0.30);
                            //this._transformEffect.M2.energy.position.set( arr[value - 1].x, arr[value - 1].y);
                            active.addChild(this._portraitTransformEffect.M3.energy);

                            //this._portraitTransformEffect.M3.energy.playLoop();
                            active.addChild(lbl);
                            //active.visible = true;
                        }
                        if(this._portraitTransformEffect.M3.blast) {
                            //active.visible = true;

                            this._portraitTransformEffect.M3.blast.visible = false;
                            this._portraitTransformEffect.M3.blast.anchor.set(0.36, 0.37);
                            active.addChild(this._portraitTransformEffect.M3.blast);

                            //this._portraitTransformEffect.M3.blast.playLoop();
                        }
                        break;
                    case 3:

                        if(this._portraitTransformEffect.M4.meterEnergy) {
                            //active.visible = true;
                            this._portraitTransformEffect.M4.meterEnergy.visible = false;
                            this._portraitTransformEffect.M4.meterEnergy.scale.set(1.35);
                            this._portraitTransformEffect.M4.meterEnergy.position.set(50, 50);
                            active.addChildAt(this._portraitTransformEffect.M4.meterEnergy, 0);
                        }

                        if(this._portraitTransformEffect.M4.flip) {
                            //active.visible = true;

                            this._portraitTransformEffect.M4.flip.visible = false;
                            this._portraitTransformEffect.M4.flip.scale.set(1.25);
                            this._portraitTransformEffect.M4.flip.anchor.set(0.22, 0.21);
                            active.addChild(this._portraitTransformEffect.M4.flip);

                            //this._portraitTransformEffect.M4.flip.visible = true;
                            //this._portraitTransformEffect.M4.flip.playLoop();

                            //this._transformEffect.M4.flip.playLoop();
                            //active.visible = true;
                            //this._portraitTransformEffect.M4.flip.getAnimationAutoShowHide(undefined, false);
                        }
                        if(this._portraitTransformEffect.M4.energy) {
                            //active.visible = true;

                            this._portraitTransformEffect.M4.energy.visible = false;
                            this._portraitTransformEffect.M4.energy.scale.set(1.25);
                            this._portraitTransformEffect.M4.energy.anchor.set(0.31, 0.315);
                            //this._transformEffect.M2.energy.position.set( arr[value - 1].x, arr[value - 1].y);
                            active.addChild(this._portraitTransformEffect.M4.energy);

                            //this._portraitTransformEffect.M4.energy.playLoop();
                            //active.visible = true;
                            active.addChild(lbl);
                        }
                        if(this._portraitTransformEffect.M4.blast) {
                            //active.visible = true;

                            this._portraitTransformEffect.M4.blast.visible = false;
                            this._portraitTransformEffect.M4.blast.anchor.set(0.36, 0.37);
                            active.addChild(this._portraitTransformEffect.M4.blast);

                            //this._portraitTransformEffect.M4.blast.playLoop();
                        }
                        break;
                    case 4:

                        if(this._portraitTransformEffect.M5.meterEnergy) {
                            //active.visible = true;
                            this._portraitTransformEffect.M5.meterEnergy.visible = false;
                            this._portraitTransformEffect.M5.meterEnergy.scale.set(1.35);
                            this._portraitTransformEffect.M5.meterEnergy.position.set(50, 50);
                            active.addChildAt(this._portraitTransformEffect.M5.meterEnergy, 0);
                        }

                        if(this._portraitTransformEffect.M5.flip) {
                            //active.visible = true;

                            this._portraitTransformEffect.M5.flip.visible = false;
                            this._portraitTransformEffect.M5.flip.scale.set(1.25);
                            this._portraitTransformEffect.M5.flip.anchor.set(0.24, 0.21);
                            active.addChild(this._portraitTransformEffect.M5.flip);

                            //this._portraitTransformEffect.M5.flip.visible = true;
                            //this._portraitTransformEffect.M5.flip.playLoop();

                            //this._transformEffect.M4.flip.playLoop();
                            //active.visible = true;
                            //this._portraitTransformEffect.M5.flip.getAnimationAutoShowHide(undefined, false);
                        }
                        if(this._portraitTransformEffect.M5.energy) {
                            //active.visible = true;

                            this._portraitTransformEffect.M5.energy.visible = false;
                            this._portraitTransformEffect.M5.energy.scale.set(1.25);
                            this._portraitTransformEffect.M5.energy.anchor.set(0.34, 0.32);
                            //this._transformEffect.M2.energy.position.set( arr[value - 1].x, arr[value - 1].y);
                            active.addChild(this._portraitTransformEffect.M5.energy);

                            //this._portraitTransformEffect.M5.energy.playLoop();
                            //active.visible = true;
                            active.addChild(lbl);
                        }
                        if(this._portraitTransformEffect.M5.blast) {
                            //active.visible = true;

                            this._portraitTransformEffect.M5.blast.visible = false;
                            this._portraitTransformEffect.M5.blast.anchor.set(0.36, 0.37);
                            active.addChild(this._portraitTransformEffect.M5.blast);

                            //this._portraitTransformEffect.M5.blast.playLoop();
                        }
                        break;
                }
            }

            this._portraitFrameWrapper.addChild(inactive);
            this._portraitFrameWrapper.addChild(active);
            if(filled && value < 4) {
                this._portraitFrameWrapper.addChild(filled);
            }
        });

        this._portraitHolder.addChild(this._portraitFrameWrapper);
    }

    protected createLandscapeIndicators():void {
        this._landscapeFrameWrapper = new PIXI.Sprite();
        this._landscapeFrameWrapper.x = 119;
        this._landscapeFrameWrapper.y = 234;
        this._landscapeFrameWrapper.scale.set(0.75, 0.75);

        const arr:PIXI.Sprite [] = [];

        const frameBottom:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("blankMeterLandscape")[0]);
        frameBottom.name = "frameId_" + 3;
        this._landscapeFrameWrapper.addChild(frameBottom);
        frameBottom.scale.set(1.4, 1.4);


        [0, 1, 2].forEach((value) => {
           const frame:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("blankMeterLandscape")[0]);
           frame.name = "frameId_" + value;
           //frame.alpha = 0.6;
           frame.y = value * 100;
           frame.scale.set(1.4, 1.4);

           arr.push(frame);
           this._landscapeIndicatorFrames.push(frame);
           this._landscapeFrameWrapper.addChild(frame);
        });
        arr.push(frameBottom);

        // positioning of frames
        arr[0].y = 3;

        arr[1].x = 7;
        arr[1].y = 114;

        arr[2].x = 11;
        arr[2].y = 232;

        arr[3].x = 9;
        arr[3].y = 347; //arr[3].y = 367;



        [0, 1, 2, 3].forEach((value) => {
            const inactive:PIXI.Sprite = this._landscapeDeactivated[value];
            const active:PIXI.Sprite = new PIXI.Sprite();

            this._landscapeActivated[value] = active.addChild(this._landscapeActivated[value]);
            let filled:PIXI.Sprite | null = this._landscapeFilled[value];

            // TODO: Special handling for M1 big ass buffalo
            if(value === 0) {

                inactive.x = -55;
                inactive.y = -180;
                inactive.scale.set(1.45, 1.45);
                //inactive.anchor.set(0, 0);
                inactive.name = "inactive_" + value;

                active.x = -55;
                active.y = -180;
                active.scale.set(1.15, 1.15);
                //active.anchor.set(0, 0);
                active.name = "active_" + value;
                active.visible = false;

                //filled.x = -40;
                //filled.y = -190;
                //filled.name = "filled_" + value;
                filled = null;

                // TODO: ADD GLOW FRAME

                if(this._transformEffect.M1.energy) {
                    this._transformEffect.M1.energy.visible = false;
                    this._transformEffect.M1.energy.anchor.set(0.35, 0.35);
                    this._transformEffect.M1.energy.scale.set(2.2);
                    active.addChild(this._transformEffect.M1.energy);
                    //this._transformEffect.M1.energy.playLoop();
                }

                // MP LABEL
                const m1lbl:PIXI.BitmapText = this._mpLabelsLandscape[0];
                m1lbl.y = 95;
                active.addChild(m1lbl);

                // TODO: ADD BLAST
            }
            else {
                inactive.x = arr[value - 1].x;
                inactive.y = arr[value - 1].y;
                inactive.scale.set(1.45, 1.45);
                inactive.anchor.set(0, 0);
                inactive.name = "inactive_" + value;

                active.x = arr[value - 1].x;
                active.y = arr[value - 1].y;
                active.scale.set(1.45, 1.45);
                active.anchor.set(0, 0);
                active.name = "active_" + value;
                active.visible = false;

                filled.x = arr[value - 1].x + 25;
                filled.y = arr[value - 1].y + 20;
                filled.name = "filled_" + value;
                filled.visible = false;

                const lbl:PIXI.BitmapText = this._mpLabelsLandscape[value];
                lbl.y = 50;

                switch(value) {
                    case 1:
                        //console.log("!!!!!!!!!!! POSITION M2 METER, x: " + active.getGlobalPosition().x + ", y: " + active.getGlobalPosition().y);


                        if(this._transformEffect.M2.meterEnergy) {
                            //active.visible = true;
                            this._transformEffect.M2.meterEnergy.visible = false;
                            this._transformEffect.M2.meterEnergy.scale.set(1.1);
                            this._transformEffect.M2.meterEnergy.position.set(40, 40);
                            active.addChildAt(this._transformEffect.M2.meterEnergy, 0);
                        }

                        if(this._transformEffect.M2.flip) {
                            //active.visible = true;

                            this._transformEffect.M2.flip.visible = false;
                            this._transformEffect.M2.flip.anchor.set(0.23, 0.22);
                            active.addChild(this._transformEffect.M2.flip);

                            //this._transformEffect.M2.flip.playLoop();
                            //active.visible = true;
                            //this._transformEffect.M2.flip.getAnimationAutoShowHide(undefined, false);
                        }

                        if(this._transformEffect.M2.energy) {
                            this._transformEffect.M2.energy.visible = false;
                            this._transformEffect.M2.energy.anchor.set(0.31, 0.29);
                            active.addChild(this._transformEffect.M2.energy);

                            //active.visible = true;
                            //this._transformEffect.M2.energy.playLoop();
                            active.addChild(lbl);
                        }


                        if(this._transformEffect.M2.blast) {
                            //active.visible = true;

                            this._transformEffect.M2.blast.visible = false;
                            this._transformEffect.M2.blast.anchor.set(0.36, 0.37);
                            active.addChild(this._transformEffect.M2.blast);

                            //this._transformEffect.M2.blast.playLoop();
                        }
                        break;
                    case 2:
                        //console.log("!!!!!!!!!!! POSITION M3 METER, x: " + active.getGlobalPosition().x + ", y: " + active.getGlobalPosition().y);

                        if(this._transformEffect.M3.meterEnergy) {
                            //active.visible = true;
                            this._transformEffect.M3.meterEnergy.visible = false;
                            this._transformEffect.M3.meterEnergy.scale.set(1.1);
                            this._transformEffect.M3.meterEnergy.position.set(40, 40);
                            active.addChildAt(this._transformEffect.M3.meterEnergy, 0);
                        }

                        if(this._transformEffect.M3.flip) {
                            //active.visible = true;

                            this._transformEffect.M3.flip.visible = false;
                            this._transformEffect.M3.flip.anchor.set(0.23, 0.21);
                            active.addChild(this._transformEffect.M3.flip);

                            //this._transformEffect.M3.flip.playLoop();
                            //active.visible = true;
                            //this._transformEffect.M3.flip.getAnimationAutoShowHide(undefined, false);
                        }
                        if(this._transformEffect.M3.energy) {
                            //active.visible = true;

                            this._transformEffect.M3.energy.visible = false;
                            this._transformEffect.M3.energy.anchor.set(0.31, 0.29);
                            //this._transformEffect.M2.energy.position.set( arr[value - 1].x, arr[value - 1].y);
                            active.addChild(this._transformEffect.M3.energy);
                            //this._transformEffect.M3.energy.playLoop();

                            active.addChild(lbl);
                        }
                        if(this._transformEffect.M3.blast) {
                            //active.visible = true;

                            this._transformEffect.M3.blast.visible = false;
                            this._transformEffect.M3.blast.anchor.set(0.36, 0.37);
                            active.addChild(this._transformEffect.M3.blast);

                            //this._transformEffect.M3.blast.playLoop();
                        }
                        break;
                    case 3:
                        //console.log("!!!!!!!!!!! POSITION M4 METER, x: " + active.getGlobalPosition().x + ", y: " + active.getGlobalPosition().y);
                        if(this._transformEffect.M4.meterEnergy) {
                            //active.visible = true;
                            this._transformEffect.M4.meterEnergy.visible = false;
                            this._transformEffect.M4.meterEnergy.scale.set(1.1);
                            this._transformEffect.M4.meterEnergy.position.set(40, 40);
                            active.addChildAt(this._transformEffect.M4.meterEnergy, 0);
                        }
                        if(this._transformEffect.M4.flip) {
                            //active.visible = true;

                            this._transformEffect.M4.flip.visible = false;
                            this._transformEffect.M4.flip.anchor.set(0.22, 0.23);
                            active.addChild(this._transformEffect.M4.flip);

                            //this._transformEffect.M4.flip.playLoop();
                            //active.visible = true;
                            //this._transformEffect.M4.flip.getAnimationAutoShowHide(undefined, false);
                        }
                        if(this._transformEffect.M4.energy) {
                            //active.visible = true;

                            this._transformEffect.M4.energy.visible = false;
                            this._transformEffect.M4.energy.anchor.set(0.31, 0.3);
                            //this._transformEffect.M2.energy.position.set( arr[value - 1].x, arr[value - 1].y);
                            active.addChild(this._transformEffect.M4.energy);
                            //this._transformEffect.M4.energy.playLoop();

                            active.addChild(lbl);
                        }
                        if(this._transformEffect.M4.blast) {
                            //active.visible = true;

                            this._transformEffect.M4.blast.visible = false;
                            this._transformEffect.M4.blast.anchor.set(0.36, 0.37);
                            active.addChild(this._transformEffect.M4.blast);

                            //this._transformEffect.M4.blast.playLoop();
                        }
                        break;
                }
            }

            this._landscapeFrameWrapper.addChild(inactive);
            this._landscapeFrameWrapper.addChild(active);
            if(filled && value < 4) {
                this._landscapeFrameWrapper.addChild(filled);
            }
        });


        const inactiveBottom:PIXI.Sprite = this._landscapeDeactivated[4];
        const activeBottom:PIXI.Sprite = new PIXI.Sprite();
        this._landscapeActivated[4] = activeBottom.addChild(this._landscapeActivated[4]);

        inactiveBottom.x = arr[3].x + 2;
        inactiveBottom.y = arr[3].y + 5;
        inactiveBottom.scale.set(1.85, 1.85);
        inactiveBottom.anchor.set(0.15, 0.20);
        inactiveBottom.name = "inactive_4";

        activeBottom.x = arr[3].x + 10;
        activeBottom.y = arr[3].y + 10;
        activeBottom.scale.set(1.55, 1.55);
        this._landscapeActivated[4].anchor.set(0.15, 0.20);
        activeBottom.name = "active_4";
        activeBottom.visible = false;

        if(this._transformEffect.M5.meterEnergy) {
            //activeBottom.visible = true;
            this._transformEffect.M5.meterEnergy.visible = false;
            this._transformEffect.M5.meterEnergy.scale.set(1);
            this._transformEffect.M5.meterEnergy.position.set(35, 35);
            activeBottom.addChildAt(this._transformEffect.M5.meterEnergy, 0);

            //console.log("!!!!!!!!!!! POSITION M5 METER, x: " + activeBottom.getGlobalPosition().x + ", y: " + activeBottom.getGlobalPosition().y);
        }


        if(this._transformEffect.M5.flip) {
            //activeBottom.visible = true;

            this._transformEffect.M5.flip.visible = false;
            this._transformEffect.M5.flip.anchor.set(0.255, 0.255);
            activeBottom.addChild(this._transformEffect.M5.flip);

            //this._transformEffect.M5.flip.playLoop();
            //this._transformEffect.M5.flip.getAnimationAutoShowHide(undefined, false);
            //activeBottom.visible = true;
        }
        if(this._transformEffect.M5.energy) {
            //activeBottom.visible = true;
            this._transformEffect.M5.energy.visible = false;
            this._transformEffect.M5.energy.anchor.set(0.35, 0.35);
            //this._transformEffect.M2.energy.position.set( arr[value - 1].x, arr[value - 1].y);
            activeBottom.addChild(this._transformEffect.M5.energy);

            const lbl:PIXI.BitmapText = this._mpLabelsLandscape[4];
            lbl.y = 40;
            activeBottom.addChild(lbl);
            //this._transformEffect.M5.energy.playLoop();
        }
        if(this._transformEffect.M5.blast) {
            //activeBottom.visible = true;
            this._transformEffect.M5.blast.visible = false;
            this._transformEffect.M5.blast.anchor.set(0.36, 0.37);
            activeBottom.addChild(this._transformEffect.M5.blast);

            //this._transformEffect.M5.blast.playLoop();
        }

        const filledBottom:PIXI.Sprite = this._landscapeFilled[4];
        filledBottom.x = arr[3].x + 25;
        filledBottom.y = arr[3].y + 20;
        filledBottom.name = "filled_4";
        filledBottom.visible = false;

        this._landscapeFilled.push(filledBottom);


        this._landscapeFrameWrapper.addChild(inactiveBottom);
        this._landscapeFrameWrapper.addChild(activeBottom);
        this._landscapeFrameWrapper.addChild(filledBottom);

        this._landscapeHolder.addChild(this._landscapeFrameWrapper);

        //this.activateEnteringFS();
    }

    public activateEnteringFS(mode:string = "FREESPIN_TRANSFORM"):void {
        this._isTotallyFilled = false;
        this._landscapeFilled[0].visible = true;
        this._portraitFilled[0].visible = true;

        this._landscapeActivated[0].parent.visible = true;
        this._portraitActivated[0].parent.visible = true;
        WinterHoardGameModuleConfig.symbolDataStopped.isFilled = false;

        this._landscapeActivated.forEach((sprite, index) => {
            if(index > 0) {
                sprite.visible = true;
                sprite.parent.visible = true;
            }
        });

        this._portraitActivated.forEach((sprite, index) => {
            if(index > 0) {
                sprite.visible = true;
                sprite.parent.visible  = true;
            }
        });
    }

    public deactivateExitingFS():void {
        this._landscapeActivated.forEach((sprite) => {
            sprite.parent.visible = false;
        });

        this._portraitActivated.forEach((sprite) => {
            sprite.parent.visible = false;
        });

        this._landscapeActivated[0].parent.visible = false;
        this._portraitActivated[0].parent.visible = false;

        // TODO: Hide frame
        /*this._landscapeIndicatorFrames.forEach((frame) => {
            frame.visible = true;
        });
        this._portraitIndicatorFrames.forEach((frame) => {
            frame.visible = true;
        });*/

        this.resetFilled();
        this.resetMeterEnergy();
        this.stopRaySpine();

        this._isTotallyFilled = false;

        /*[1, 2, 3, 4].forEach((value) => {
            this.resetEnergy(value);
        });*/

    }

    public playEnergyActivation(level:number, mode:string = "FREESPIN_TRANSFORM", fsLeft:number = 0, isRestore:boolean = false):Timeline {
        // TODO: play energy activation, regardless of orientation (only one wrapper will be rendered anyway)
        /*
            level 4 = M5
            level 3 = M4
            level 2 = M3
            level 1 = M2 and M1-activation
         */

        const tl:TimelineLite = new TimelineLite();

        // TODO: Switch
        let landscapeTransform:any;
        let portraitTransform:any;
        switch(level) {
            case 4:
                landscapeTransform = this._transformEffect.M5;
                portraitTransform = this._portraitTransformEffect.M5;
                break;
            case 3:
                landscapeTransform = this._transformEffect.M4;
                portraitTransform = this._portraitTransformEffect.M4;
                break;
            case 2:
                landscapeTransform = this._transformEffect.M3;
                portraitTransform = this._portraitTransformEffect.M3;
                break;
            case 1:
                landscapeTransform = this._transformEffect.M2;
                portraitTransform = this._portraitTransformEffect.M2;
                break;
            case 0:
                landscapeTransform = this._transformEffect.M1;
                portraitTransform = this._portraitTransformEffect.M1;
                break;
        }

        // BLAST
            tl.add([
                (landscapeTransform.blast)? landscapeTransform.blast.getAnimationAutoShowHide() : () => {},
                (portraitTransform.blast)? portraitTransform.blast.getAnimationAutoShowHide() : () => {}
            ]);
        // FLIP - TRANSFORM AND COMBINED
            if(level > 0 && (mode === "FREESPIN_TRANSFORM" || mode === "FREESPIN_COMBINED")) {
                if(fsLeft > 0 && !isRestore){
                    //debugger;
                }
                tl.add([
                    (fsLeft && fsLeft > 0 && !isRestore)? () => {
                        SlotGame.keypad.setZeroBetSpinCounter(fsLeft);
                    } : () => {}
                ]);
                tl.add([
                    (!isRestore)? ()=>{SoundPlayer.playEffect(WinterHoardSoundConfig.SYMBOL_CHANGE_ON_METER)} : () => {},
                    (landscapeTransform.flip && portraitTransform.flip)? () => {
                        this._landscapeActivated[level].visible = false;
                        this._portraitActivated[level].visible = false;
                    } : () => {},
                    (landscapeTransform.flip) ? landscapeTransform.flip.getAnimationAutoShowHide(undefined, false) : () => {
                    },
                    (portraitTransform.flip) ? portraitTransform.flip.getAnimationAutoShowHide(undefined, false) : () => {
                    },
                    (!isRestore && level <= 4 && !this._isTotallyFilled)? WinterHoardGameModuleConfig.addFsView.playSpine(undefined, undefined, undefined, false) : () => {},
                    (!isRestore)? this.playThunderSpine(this._meterThunder, 0, true) : () => {},
                    (!isRestore)? this.playThunderSpine(this._bigThunder, 0, true) : () => {},
                    (level === 1)? this.playRaySpine() : () => {},
                    (level === 1)? WinterHoardGameModuleConfig.energyCollector.playEnergyEnd(0, 0) : () => {}

                    // TODO: Hide frame
                    //() => this._landscapeIndicatorFrames[level].visible = false,
                    //() => this._portraitIndicatorFrames[level].visible = false,
                    //() => this._landscapeActivated[level].visible = false,
                    //() => this._portraitActivated[level].visible = false,
                    /*(fsLeft && fsLeft > 0 && !isRestore)? () => {
                        SlotGame.keypad.setZeroBetSpinCounter(fsLeft);
                    } : () => {}*/
                ], "+=0.2");

                /*if(!isRestore) {
                    tl.add([
                        this.playThunderSpine(this._meterThunder, 0, true),
                        this.playThunderSpine(this._bigThunder, 0, true),
                        (level === 1)? this.playRaySpine() : () => {}
                    ], "+=0.05");
                }
                else {
                    tl.add([
                        (level === 1)? this.playRaySpine() : () => {}
                    ], "+=0.05");
                }*/

            }
            if(level > 0 && mode === "FREESPIN_MULTIPLIER") {
                tl.add([
                    (fsLeft && fsLeft > 0 && !isRestore)? () => {
                        SlotGame.keypad.setZeroBetSpinCounter(fsLeft);
                    } : () => {}
                ]);

                tl.add([
                    (!isRestore)? ()=>{SoundPlayer.playEffect(WinterHoardSoundConfig.SYMBOL_CHANGE_ON_METER)} : () => {},
                    (!isRestore && level <= 4 && !this._isTotallyFilled)? WinterHoardGameModuleConfig.addFsView.playSpine(undefined, undefined, undefined, false) : () => {},
                    /*(fsLeft && fsLeft > 0 && !isRestore)? () => {
                        SlotGame.keypad.setZeroBetSpinCounter(fsLeft);
                    } : () => {}*/
                    (!isRestore)? this.playThunderSpine(this._meterThunder, 0, true) : () => {},
                    (!isRestore)? this.playThunderSpine(this._bigThunder, 0, true) : () => {},
                    (level === 1)? this.playRaySpine() : () => {},
                    (level === 1)? WinterHoardGameModuleConfig.energyCollector.playEnergyEnd(0, 0) : () => {}

                ], "+=0.2");

                /*if(!isRestore) {
                    tl.add([
                        this.playThunderSpine(this._meterThunder),
                        this.playThunderSpine(this._bigThunder),
                        (level === 1)? this.playRaySpine() : () => {}
                    ], "+=0.05");
                }
                else {
                    tl.add([
                        (level === 1)? this.playRaySpine() : () => {}
                    ], "+=0.05");
                }*/
            }


        // ENERGY
            tl.add([
                (landscapeTransform.energy)? () => {
                    if(landscapeTransform.energy) {
                        landscapeTransform.energy.visible = true;
                        landscapeTransform.energy.playLoop();
                    }
                } : () => {},
                (portraitTransform.flip)? () => {
                    if(portraitTransform.energy) {
                        portraitTransform.energy.visible = true;
                        portraitTransform.energy.playLoop();
                    }
                }: () => {}
            ]);

        // MP TEXT - MULTIPLIER AND COMBINED // TODO: MOVE UPADET OF MP HERE!

        tl.add(() => {
            if(level === 0) {
                WinterHoardGameModuleConfig.symbolDataStopped.collectedBefore = 20;
                [0, 1, 2, 3, 4].forEach((rid) => {
                    [0, 1, 2 , 3].forEach((sid) => {
                        const symbol:WinterHoardReelSymbol | null = <WinterHoardReelSymbol> Reels.getSymbol(rid, sid);
                        if(symbol && symbol.symName === "M1") {
                            symbol.playNormalSpine();
                        }
                    });
                });
            }
        }, "+=1.0");

        return tl;
    }

    public resetEnergy(level:number):void {
        let landscapeTransform:any;
        let portraitTransform:any;
        switch(level) {
            case 4:
                landscapeTransform = this._transformEffect.M5;
                portraitTransform = this._portraitTransformEffect.M5;
                break;
            case 3:
                landscapeTransform = this._transformEffect.M4;
                portraitTransform = this._portraitTransformEffect.M4;
                break;
            case 2:
                landscapeTransform = this._transformEffect.M3;
                portraitTransform = this._portraitTransformEffect.M3;
                break;
            case 1:
                landscapeTransform = this._transformEffect.M2;
                portraitTransform = this._portraitTransformEffect.M2;
                break;
            case 0:
                landscapeTransform = this._transformEffect.M1;
                portraitTransform = this._portraitTransformEffect.M1;
                break;
        }

        if(landscapeTransform && portraitTransform) {
            landscapeTransform.energy.stopLoop();
            landscapeTransform.energy.visible = false;
            portraitTransform.energy.stopLoop();
            portraitTransform.energy.visible = false;

            landscapeTransform.flip.visible = false;
            portraitTransform.flip.visible = false;
            landscapeTransform.flip.setFrame(0);
            portraitTransform.flip.setFrame(0);
        }
    }

    public fillMeterEnergy(symLevel:number, energyLevel:number):void {
        /**
         4: M5
         3: M4
         2: M3
         1: M2
         */
        let landscapeEnergy:PIXI.Sprite | null = null;
        let landscapeSpine:PIXI.spine.Spine | null = null;

        let portraitEnergy:PIXI.Sprite | null = null;
        let portraitSpine:PIXI.spine.Spine | null = null;

        switch(symLevel) {
            case 1:
                if(this._transformEffect.M2 && this._transformEffect.M2.meterEnergy) {
                    landscapeEnergy = this._transformEffect.M2.meterEnergy;
                    landscapeSpine = <PIXI.spine.Spine>landscapeEnergy.getChildAt(0);
                }
                if(this._portraitTransformEffect.M2 && this._portraitTransformEffect.M2.meterEnergy) {
                    portraitEnergy = this._portraitTransformEffect.M2.meterEnergy;
                    portraitSpine = <PIXI.spine.Spine>portraitEnergy.getChildAt(0);
                }
                break;
            case 2:
                if(this._transformEffect.M3 && this._transformEffect.M3.meterEnergy) {
                    landscapeEnergy = this._transformEffect.M3.meterEnergy;
                    landscapeSpine = <PIXI.spine.Spine>landscapeEnergy.getChildAt(0);
                }
                if(this._portraitTransformEffect.M3 && this._portraitTransformEffect.M3.meterEnergy) {
                    portraitEnergy = this._portraitTransformEffect.M3.meterEnergy;
                    portraitSpine = <PIXI.spine.Spine>portraitEnergy.getChildAt(0);
                }
                break;
            case 3:
                if(this._transformEffect.M4 && this._transformEffect.M4.meterEnergy) {
                    landscapeEnergy = this._transformEffect.M4.meterEnergy;
                    landscapeSpine = <PIXI.spine.Spine>landscapeEnergy.getChildAt(0);
                }
                if(this._portraitTransformEffect.M4 && this._portraitTransformEffect.M4.meterEnergy) {
                    portraitEnergy = this._portraitTransformEffect.M4.meterEnergy;
                    portraitSpine = <PIXI.spine.Spine>portraitEnergy.getChildAt(0);
                }
                break;
            case 4:
                if(this._transformEffect.M5 && this._transformEffect.M5.meterEnergy) {
                    landscapeEnergy = this._transformEffect.M5.meterEnergy;
                    landscapeSpine = <PIXI.spine.Spine>landscapeEnergy.getChildAt(0);
                }
                if(this._portraitTransformEffect.M5 && this._portraitTransformEffect.M5.meterEnergy) {
                    portraitEnergy = this._portraitTransformEffect.M5.meterEnergy;
                    portraitSpine = <PIXI.spine.Spine>portraitEnergy.getChildAt(0);
                }
                break;
        }



        if(landscapeEnergy && landscapeSpine && portraitEnergy && portraitSpine) {
            switch (symLevel) {
                case 1:
                    landscapeEnergy.visible = true;
                    portraitEnergy.visible = true;

                    if(energyLevel - 1 > -1) {
                        landscapeSpine.state.setAnimation(0, this._landscapeMeterEnergyAnimations.M2[energyLevel - 1], false);
                        portraitSpine.state.setAnimation(0, this._portraitMeterEnergyAnimations.M2[energyLevel - 1], false);
                    }
                    break;
                case 2:
                    landscapeEnergy.visible = true;
                    portraitEnergy.visible = true;

                    if(energyLevel - 1 > -1) {
                        landscapeSpine.state.setAnimation(0, this._landscapeMeterEnergyAnimations.M3[energyLevel - 1], false);
                        portraitSpine.state.setAnimation(0, this._portraitMeterEnergyAnimations.M3[energyLevel - 1], false);
                    }
                    break;
                case 3:
                    landscapeEnergy.visible = true;
                    portraitEnergy.visible = true;

                    if(energyLevel - 1 > -1) {
                        landscapeSpine.state.setAnimation(0, this._landscapeMeterEnergyAnimations.M4[energyLevel - 1], false);
                        portraitSpine.state.setAnimation(0, this._portraitMeterEnergyAnimations.M4[energyLevel - 1], false);
                    }
                    break;
                case 4:
                    landscapeEnergy.visible = true;
                    portraitEnergy.visible = true;

                    if(energyLevel - 1 > -1) {
                        landscapeSpine.state.setAnimation(0, this._landscapeMeterEnergyAnimations.M5[energyLevel - 1], false);
                        portraitSpine.state.setAnimation(0, this._portraitMeterEnergyAnimations.M5[energyLevel - 1], false);
                    }
                    break;
            }
        }

    }

    resetMeterEnergy():void {
        let landscapeEnergy:PIXI.Sprite | null = null;
        let landscapeSpine:PIXI.spine.Spine | null = null;

        let portraitEnergy:PIXI.Sprite | null = null;
        let portraitSpine:PIXI.spine.Spine | null = null;

        [1, 2, 3, 4].forEach((value) => {
            switch(value) {
                case 1:
                    if(this._transformEffect.M2 && this._transformEffect.M2.meterEnergy) {
                        landscapeEnergy = this._transformEffect.M2.meterEnergy;
                        landscapeSpine = <PIXI.spine.Spine>landscapeEnergy.getChildAt(0);

                        landscapeSpine.state.setEmptyAnimation(0,0);
                    }
                    if(this._portraitTransformEffect.M2 && this._portraitTransformEffect.M2.meterEnergy) {
                        portraitEnergy = this._portraitTransformEffect.M2.meterEnergy;
                        portraitSpine = <PIXI.spine.Spine>portraitEnergy.getChildAt(0);

                        portraitSpine.state.setEmptyAnimation(0, 0);
                    }
                    break;
                case 2:
                    if(this._transformEffect.M3 && this._transformEffect.M3.meterEnergy) {
                        landscapeEnergy = this._transformEffect.M3.meterEnergy;
                        landscapeSpine = <PIXI.spine.Spine>landscapeEnergy.getChildAt(0);

                        landscapeSpine.state.setEmptyAnimation(0,0);
                    }
                    if(this._portraitTransformEffect.M3 && this._portraitTransformEffect.M3.meterEnergy) {
                        portraitEnergy = this._portraitTransformEffect.M3.meterEnergy;
                        portraitSpine = <PIXI.spine.Spine>portraitEnergy.getChildAt(0);

                        portraitSpine.state.setEmptyAnimation(0, 0);
                    }
                    break;
                case 3:
                    if(this._transformEffect.M4 && this._transformEffect.M4.meterEnergy) {
                        landscapeEnergy = this._transformEffect.M4.meterEnergy;
                        landscapeSpine = <PIXI.spine.Spine>landscapeEnergy.getChildAt(0);

                        landscapeSpine.state.setEmptyAnimation(0,0);
                    }
                    if(this._portraitTransformEffect.M4 && this._portraitTransformEffect.M4.meterEnergy) {
                        portraitEnergy = this._portraitTransformEffect.M4.meterEnergy;
                        portraitSpine = <PIXI.spine.Spine>portraitEnergy.getChildAt(0);

                        portraitSpine.state.setEmptyAnimation(0, 0);
                    }
                    break;
                case 4:
                    if(this._transformEffect.M5 && this._transformEffect.M5.meterEnergy) {
                        landscapeEnergy = this._transformEffect.M5.meterEnergy;
                        landscapeSpine = <PIXI.spine.Spine>landscapeEnergy.getChildAt(0);

                        landscapeSpine.state.setEmptyAnimation(0,0);
                    }
                    if(this._portraitTransformEffect.M5 && this._portraitTransformEffect.M5.meterEnergy) {
                        portraitEnergy = this._portraitTransformEffect.M5.meterEnergy;
                        portraitSpine = <PIXI.spine.Spine>portraitEnergy.getChildAt(0);

                        portraitSpine.state.setEmptyAnimation(0, 0);
                    }
                    break;
            }

            if(landscapeEnergy) {
                landscapeEnergy.visible = false;
            }
            if(portraitEnergy) {
                portraitEnergy.visible = false;
            }
        });

    }

    public updateAndShowMultiplier(mode:string = "FREESPIN_TRANSFORM", symMps:{M1:number, M2:number, M3:number, M4:number, M5:number} = {
        M1: 0,
        M2: 0,
        M3: 0,
        M4: 0,
        M5: 0
    }, fsLeft:number = 0, level:number = 0, isRestore:boolean = false, showExtra:boolean = false):Timeline {
        const tl:Timeline = new TimelineLite();

        if((mode === "FREESPIN_MULTIPLIER" || mode === "FREESPIN_COMBINED") && symMps !== undefined) {

            tl.add(() => {
                this._mpLabelsLandscape[4].text = (symMps["M5"] && symMps["M5"] > 1)? "x" + symMps["M5"] : "";
                this._mpLabelsLandscape[3].text = (symMps["M4"] && symMps["M4"] > 1)? "x" + symMps["M4"] : "";
                this._mpLabelsLandscape[2].text = (symMps["M3"] && symMps["M3"] > 1)? "x" + symMps["M3"] : "";
                this._mpLabelsLandscape[1].text = (symMps["M2"] && symMps["M2"] > 1)? "x" + symMps["M2"] : "";
                this._mpLabelsLandscape[0].text = (symMps["M1"] && symMps["M1"] > 1)? "x" + symMps["M1"] : "";

                this._mpLabelsPortrait[4].text = (symMps["M5"] && symMps["M5"] > 1)? "x" + symMps["M5"] : "";
                this._mpLabelsPortrait[3].text = (symMps["M4"] && symMps["M4"] > 1)? "x" + symMps["M4"] : "";
                this._mpLabelsPortrait[2].text = (symMps["M3"] && symMps["M3"] > 1)? "x" + symMps["M3"] : "";
                this._mpLabelsPortrait[1].text = (symMps["M2"] && symMps["M2"] > 1)? "x" + symMps["M2"] : "";
                this._mpLabelsPortrait[0].text = (symMps["M1"] && symMps["M1"] > 1)? "x" + symMps["M1"] : "";

                this.showLabel(false, mode);

                this._mpLabelsLandscape.forEach((label) => {
                    label.visible = true;
                });

                this._mpLabelsPortrait.forEach((label) => {
                    label.visible = true;
                });


                if(!isRestore) {
                    //WinterHoardGameModuleConfig.addFsView.playSpine(undefined, undefined, undefined, false);
                }
            }, "+=0.5");
            tl.add(() => {
                WinterHoardGameModuleConfig.symbolDataStopped.symbolMultipliers = symMps;
            }, "+=0.3");

        }


        return tl;
    }



    public fillSymIndicator(level:number, mode:string = "FREESPIN_TRANSFORM", symMps:{M1:number, M2:number, M3:number, M4:number, M5:number} = {
        M1: 0,
        M2: 0,
        M3: 0,
        M4: 0,
        M5: 0
    }, fsLeft:number = 0, isRestore:boolean = false):Timeline {
        // 4 -> 3 -> 2 -> 1
        if(level > -1) {
                const tl:TimelineLite = new TimelineLite();
                if(level === 1 && !this._isTotallyFilled) {
                    tl.add(this.playEnergyActivation(level, mode, fsLeft, isRestore));
                    tl.add(this.playEnergyActivation(0, mode, fsLeft, isRestore));
                    if(level <= 1) { // M1
                        tl.add(() => {
                            this._isTotallyFilled = true;
                        });
                    }
                    else {
                            this._isTotallyFilled = false;
                    }
                }
                else {
                    this.playEnergyActivation(level, mode, fsLeft, isRestore);
                }

                if((mode === "FREESPIN_MULTIPLIER" || mode === "FREESPIN_COMBINED") && symMps !== undefined) {
                }



                return tl;
        }

        return new TimelineLite();
    }

    public resetFilled():void {
        this._landscapeFilled.forEach((sprite) => {
            sprite.visible = false;
        });

        this._portraitFilled.forEach((sprite) => {
            sprite.visible = false;
        });

        this._mpLabelsPortrait.forEach((sprite) => {
            sprite.text = "";
            sprite.visible = false;
        });

        this._mpLabelsLandscape.forEach((sprite) => {
            sprite.text = "";
            sprite.visible = false;
        });

        this._landscapeDeactivated[0].visible = true;
        this._portraitDeactivated[0].visible = true;

        // TODO: add reset of all animations
        [0,1,2,3,4].forEach((value:number) => this.resetEnergy(value));
    }

    protected onResize(resizeData: IResizeData): void {

        this.intenseOnResize(resizeData.orientation);

        if(resizeData.orientation === Orientation.LANDSCAPE) {
            this._portraitHolder.visible = false;
            this._landscapeHolder.visible = true;

            this._landscapeHolder.x = -211;//-233;

            if(resizeData.width / resizeData.height <1.775){
                this._mpLabelsLandscape.forEach((label, index) => {
                    if(index === 0) {
                        label.x = this._labelLandscapeMultiplierX[index] =  20;
                        label.x = this._labelLandscapeCombinedX[index] =  20;
                    }
                });
            } else {
                this._mpLabelsLandscape.forEach((label, index) => {

                    if(index === 0) {
                        label.x = this._labelLandscapeMultiplierX[index] = 0;
                        label.x = this._labelLandscapeCombinedX[index] = 0;
                    }

                    label.x = this._labelLandscapeMultiplierX[index];
                });
            }
        }
        else {
            //console.log("resizeData: " + resizeData);
            //console.log(resizeData);
            this._portraitHolder.visible = true;
            this._landscapeHolder.visible = false;

            if(resizeData.height > 970) {
                this._m1FramePortrait.scale.set(1, 1);
                this._portraitFrameWrapper.scale.set(0.87, 0.87);
                this._m1FramePortrait.position.set(202,-2);
                this._portraitHolder.x = 63;//0;
                this._portraitHolder.y = -205;//-265;
                this._portraitHolder.scale.set(1,1);
            }
            else {
                //this._m1FramePortrait.scale.set(0.8, 0.8);
                //this._portraitFrameWrapper.scale.set(0.62, 0.62);
                this._m1FramePortrait.position.set(197, -4);
                this._portraitHolder.scale.set(0.6, 0.6);
                this._portraitHolder.x = 175;//126;
                this._portraitHolder.y = -110;//-155;
            }
        }
    }
}